import { useReduxSelector } from 'services/hooks';

export const useTopBar = () => {
  const money = useReduxSelector((redux) => redux.player.main.money);
  const energy = useReduxSelector((redux) => redux.player.main.energy);
  const mood = useReduxSelector((redux) => redux.player.main.mood);

  return { money, energy, mood };
};
